import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LIB_vehicleModels'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LIB_vehicleModelsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LIB_vehicleModelsStore",
			variables: false,
		})
	}
}

export async function load_LIB_vehicleModels(params) {
  await initClient()

	const store = new LIB_vehicleModelsStore()

	await store.fetch(params)

	return {
		LIB_vehicleModels: store,
	}
}
